import $axios from '@/axios-instance.js'

export const systemSettingsService = {
  getSystemSettings,
  saveSystemSettings
}

function getSystemSettings () {
  return $axios.get(`${process.env.ROOT_API}/system-settings`).then(response => {
    return response.data
  })
}

function saveSystemSettings (systemSettings) {
  return $axios.post(`${process.env.ROOT_API}/system-settings`, systemSettings).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/system-settings.service.js